/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global Excel, Office */

import { loadLoginComponent } from "./components/Login/LoginComponent";
import { loadReportsListComponent, showLandingView } from "./components/ReportList/ReportListComponent";
import { hasValidSession } from "./utils/session";
import { showToast } from "./utils/ui-utils";

Office.onReady(async (info) => {
    if (info.host === Office.HostType.Excel) {
        document.getElementById("sideload-msg")?.style.setProperty("display", "none");
        document.getElementById("app-body")?.style.setProperty("display", "flex");
        // A still-valid session goes straight to My Reports, as the web app skips its login
        // page for a signed-in user. An expired or unreadable token gets the sign-in form.
        if (hasValidSession()) {
            await loadReportsListComponent(() => {});
            await showLandingView();
            return;
        }
        // loadReportsListComponent is passed as the onLoginSuccess callback so the
        // HTML template is injected before showLandingView runs inside LoginComponent.
        await loadLoginComponent(() => loadReportsListComponent(() => {}));
    }
});

// Backwards-compatible global toaster
(window as any).showToaster = showToast;
